import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export class FilterModel<T> {
    constructor(public name: string,
                public matcher: (v: T) => boolean,
                public selected: boolean = true) {
    }

    matches(value: T) {
        if (!this.selected) return false;
        return this.matcher(value);
    }
}

@Component({
    selector: 'app-filter-dropdown',
    templateUrl: './filter-dropdown.component.html'
})
export class FilterDropDownComponent<T> implements OnInit {

    @Input()
    models: FilterModel<T>[] = [];

    @Input()
    placeholder: string = '';

    @Output()
    modelsChange = new EventEmitter<FilterModel<T>[]>();

    date: Date;
    minDate = new Date(2014, 1);
    nowDate = new Date;
    maxDate = new Date(this.nowDate.getFullYear(),1);

    bsConf = {
        minMode: 'year',
        dateInputFormat: 'YYYY',
        containerClass: 'theme-green custom-picker'
    };

    constructor() {

    }

    ngOnInit() {
        let isSelectAll = !this.models.some(m => {
            return !m.selected;
        });

        if (isSelectAll){
            this.date = null;
        }else{
            let selectedYearModel = this.models.filter(m => { return m.selected; });
            if (selectedYearModel.length){
                this.date = new Date(+selectedYearModel[0].name, 1);
            }
        }
    }

    checkChanged() {
        let selectedYear = this.date.getFullYear().toString();
        this.models.forEach(m => {
            m.selected = false;
            if (m.name == selectedYear) m.selected = true;
        });

        this.modelsChange.emit([...this.models]);
    }

    clear(){
        this.date = null;
        this.models.forEach(m => {
            m.selected = true;
        });

        this.modelsChange.emit([...this.models]);
    }
}
